import { render } from "./file-upload.component.vue?vue&type=template&id=819154c8&ts=true"
import script from "./file-upload.component.vue?vue&type=script&lang=ts"
export * from "./file-upload.component.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__